<template>
    <b-modal id="file-viewer" :size="type == 'pdf' ? 'lg' : 'md'" body-class="p-0" title="Görüntüleyici" hide-footer scrollable no-close-on-backdrop no-close-on-esc>
        <div v-if="type == 'pdf'">
            <div v-if="loadingTask" class="pdf-wrapper">
                <div class="pdf-loading" v-if="loading">
                    <b-spinner class="text-white"></b-spinner>
                </div>
                <div v-else class="pdf-content">
                    <pdf ref="pdf" v-for="i in numPages"
                            :key="i"
                            :src="loadingTask"
                            :page="i" 
                            :class="{'mt-1':i!=1}"></pdf>
                </div>
            </div>
        </div>
        <div v-else-if="type == 'png' || type == 'jpg' || type == 'jpeg'" class="p-50">
            <b-img :src="url" fluid></b-img>
        </div>
        <div v-else class="p-75">
            <div class="alert alert-danger mb-0">
                <div class="alert-body text-center">
                    Dosya türü <strong>(.{{type}})</strong>&nbsp;desteklenmemektedir.
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BSpinner,BImg } from 'bootstrap-vue'
import pdf from 'vue-pdf'
import { PDFDocument } from 'pdf-lib'
import Additional from '@/utilities/additional'

export default {
    components:{
        pdf,
        BSpinner,
        BImg
    },
    data(){
        return {
            loadingTask:null,
            loading:false,
            numPages: 0,
            url:null,
            type:null
        }
    },
    methods:{
        async loadPDF(url){
            const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
            const pdfDoc = await PDFDocument.load(existingPdfBytes)
            const pdfUri = await pdfDoc.save()
            this.srcCheck(pdfUri)
        },
        srcCheck(url){
            if(url){
                this.loadingTask = pdf.createLoadingTask(url)
                this.connectPdf()
            }else this.loadingTask = null
        },
        connectPdf(){
            if(this.loadingTask){
                this.loading = true
                this.loadingTask.promise.then(pdf=>{
                    this.numPages = pdf.numPages
                    this.loading = false
                })
            }
        },
        view(url){
            this.type = Additional.GetExtension(url)
            if(this.type == 'pdf'){
                this.loadPDF(url)
            }
            this.url = url
            this.$showModal('file-viewer')
        }
    }
}
</script>

<style>
.pdf-wrapper{
    background-color: rgb(100,100,100);
    height: auto;
    min-height: 300px;
}

.pdf-loading{
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pdf-wrapper .pdf-content{
    padding: 1rem;
    height: auto;
}

.annotationLayer{
    box-shadow: 0px 5px 10px 5px rgba(70,70,70,1);
}
</style>